<template>
  <div class="pet-holder">
    <div class="columns is-multiline">
      <div class="column is-3">
        <div class="field">
          <div class="control has-icons-left">
            <span class="icon is-small is-left">
              <i class="mdi mdi-magnify"></i>
            </span>
            <input
              class="input"
              type="text"
              placeholder="Buscar pet"
              v-model.trim="searchText"
            />
          </div>
        </div>
      </div>
      <div class="column is-3">
        <b-field>
          <label class="label" style="margin-right: 10px;">Status</label>
          <b-radio v-model="selectedStatus" native-value="ALL">Todos</b-radio>
          <b-radio v-model="selectedStatus" native-value="TRUE">Ativo</b-radio>
          <b-radio v-model="selectedStatus" native-value="FALSE">Inativo</b-radio>
        </b-field>
      </div>
      <div class="column is-6">
        <div class="buttons is-right">
          <button class="button is-primary" @click="openPetReportModal()">
            Relatório de entregas
          </button>
          <button class="button is-primary" @click="openCreateEditModal({})">
            Novo Pet
          </button>
        </div>
      </div>
      <div class="column is-12" v-if="pets.length > 0">
        <table class="table is-fullwidth">
          <thead>
            <tr>
              <th @click="orderBy('name')">
                <span>Nome</span>
                <i
                    class="mdi mdi-sort-ascending"
                    v-if="selectedFilter === 'name' && order === 'asc'"
                ></i>
                <i
                    class="mdi mdi-sort-descending"
                    v-else-if="selectedFilter === 'name' && order === 'desc'"
                ></i>
                <i class="mdi mdi-minus" v-else></i>
              </th>
              <th>Dono</th>
              <th>Data de nascimento</th>
              <th>Idade</th>
              <th @click="orderBy('address')">
                <span>
                  Endereço
                </span>
                <i
                    class="mdi mdi-sort-ascending"
                    v-if="selectedFilter === 'address' && order === 'asc'"
                ></i>
                <i
                    class="mdi mdi-sort-descending"
                    v-else-if="selectedFilter === 'address' && order === 'desc'"
                ></i>
                <i class="mdi mdi-minus" v-else></i>
              </th>
              <th>Habilitado para entrega</th>
              <th @click="orderBy('consumption')">
                <span>Consumo</span>
                <i
                    class="mdi mdi-sort-ascending"
                    v-if="selectedFilter === 'consumption' && order === 'asc'"
                ></i>
                <i
                    class="mdi mdi-sort-descending"
                    v-else-if="selectedFilter === 'consumption' && order === 'desc'"
                ></i>
                <i class="mdi mdi-minus" v-else></i>
              </th>
              <th>Restrições</th>
              <th>Opções</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="pet in pets" :key="pet.id">
              <td>{{ pet.name }}</td>
              <td>{{ pet.owner.name }}</td>
              <td>{{ pet.dateOfBirth | moment("DD/MM/YYYY") }}</td>
              <td>{{ getAge(pet.dateOfBirth)}}</td>
              <td>{{ getAddress(pet.owner.address) }}</td>
              <td>{{ pet.enableDelivery ? "Sim" : "Não" }}</td>
              <td>{{ pet.consumption }}g</td>
              <td v-if="pet.ingredients.length">
                <div
                  v-for="restriction in pet.ingredients"
                  :key="restriction.id"
                >
                  {{ restriction.name }}
                </div>
              </td>
              <td v-else>Nenhuma restrição</td>
              <td class="options-holder">
                <a class="option" @click="openCreateEditModal(pet)">Editar</a>
                <a class="option" @click="openPetDetailsModal(pet)">Detalhes</a>
                <a class="option" @click="remove(pet)">Excluir</a>
              </td>
            </tr>
          </tbody>
        </table>
        <paginate
          v-model="currentPage"
          :page-count="totalPages"
          :page-range="3"
          :click-handler="getData"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'ml-pagination pagination-sm'"
          :prev-class="'page-item'"
          :next-class="'page-item'"
          :next-link-class="'page-link'"
          :page-link-class="'page-link'"
          :page-class="'page-item'"
        >
        </paginate>
      </div>
      <div class="column is-12" v-else>
        <div class="no-items-to-show-msg">Nenhum pet foi encontrado.</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import CreateEditPetModal from "../components/pet/CreateEditPetComponent";
import NotificationsWrapper from "../helpers/NotificationsWrapper";
import utils from "../helpers/debounce";
import PetDetailsComponent from "../components/pet/PetDetailsComponent";
import PetDetailsByPeriodComponent from "@/components/pet/PetDetailsByPeriodComponent";
import * as moment from "moment";

export default {
  name: "Pets",
  data: () => ({
    currentPage: 1,
    searchText: "",
    selectedFilter: "name",
    order: "asc",
    pageSize: 60,
    selectedStatus: 'ALL'
  }),
  watch: {
    searchText: function() {
      this.getPetByText();
    },
    selectedStatus: function () {
      this.currentPage = 1;
      this.getData(this.currentPage);
    }
  },
  computed: {
    ...mapState({
      pets: state => state.pet.pets,
      isLoadingData: state => state.pet.loading,
      totalPages: state => state.pet.totalPages
    })
  },
  methods: {
    getAge(date){
      if (!date){
        return;
      }
      const years = moment().diff(date, "years");
      const months = moment().diff(date, "months") - years * 12;
      return `${years} anos e ${months} meses`;
    },
    getAddress(address) {
      return (
          address.street +
          ", " +
          address.number +
          ", " +
          address.neighborhood +
          ", " +
          address.cep
      );
    },
    orderBy(param){
      if(param !== this.selectedFilter){
        this.order = 'asc';
        this.selectedFilter = param;
      }else{
        this.order = this.order === 'desc' ? 'asc' : 'desc';
      }
      this.getData(0);
    },
    ...mapActions({
      getPets: "pet/getPets",
      removePet: "pet/removePet"
    }),
    ...mapMutations({
      resetFilters: "pet/resetFilters",
      setPetFilters: "pet/setQueryFilters",
      setPage: "pet/setPage"
    }),
    openCreateEditModal(pet) {
      this.$modal.show(
        CreateEditPetModal,
        { petParam: JSON.parse(JSON.stringify(pet)) },
        { width: "700px", height: "auto", adaptive: true, scrollable: true, clickToClose: false },
        {
          closed: () => {
            this.getPets();
          }
        }
      );
    },
    openPetReportModal() {
      this.$modal.show(
        PetDetailsByPeriodComponent,
        {},
        {
          width: "700px",
          height: "auto",
          adaptive: true,
          scrollable: true,
          clickToClose: false
        },
        {
          closed: () => {
            this.getPets();
          }
        }
      );
    },
    openPetDetailsModal(pet) {
      this.$modal.show(
        PetDetailsComponent,
        { pet: pet },
        { width: "700px", height: "auto", adaptive: true, scrollable: true, clickToClose: false },
        {
          closed: () => {
            this.getPets();
          }
        }
      );
    },
    getSort(){
      let sort = '';
      if(this.selectedFilter === 'address'){
        sort='owner.address.neighborhood,'+this.order;
      }else{
        sort = this.selectedFilter + ',' + this.order;
      }
      return sort;
    },
    getData(pageNum) {
      const page = pageNum - 1;
      this.currentPage = pageNum;
      this.setPage(page);
      this.resetFilters();

     let sort = this.getSort();

     let queryParam = { name: this.searchText, sort: sort, size: this.pageSize, page: page }
      if(this.selectedStatus !== "ALL") {
        queryParam.enabled = this.selectedStatus === 'TRUE';
      }
      console.log(queryParam)
      this.setPetFilters(queryParam);
      this.getPets();
    },
    remove(pet) {
      this.$modal.show("dialog", {
        title: "Aviso de exclusão!",
        text: `Você deseja excluir o pet ${pet.name}?`,
        buttons: [
          {
            title: "Excluir",
            class: "vue-dialog-button error",
            handler: () => {
              this.removePet(pet.id)
                .then(() => {
                  NotificationsWrapper.success("Pet excluído com sucesso!");
                  this.$modal.hide("dialog");
                  this.getPets();
                })
                .catch(() => {
                  NotificationsWrapper.error("Não foi possível remover o pet!");
                });
            }
          },
          {
            title: "Cancelar", // Button title
            default: true, // Will be triggered by default if 'Enter' pressed.,
            handler: () => {
              this.$modal.hide("dialog");
            }
          }
        ]
      });
    },
    getPetByText: utils.debounce(function() {
      this.resetFilters();
      let sort = this.getSort();
      this.setPetFilters({ name: this.searchText,  sort: sort, size: this.pageSize });
      this.getPets();
    }, 300)
  },
  mounted() {

  },
  created() {
    this.getPetByText();
    this.$store.commit("setSelectedViewTitle", "Pets");
  }
};
</script>

<style lang="scss" scoped>
</style>
